































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import {
  RedCapital,
  SelectedCountry,
  TitleTemplatePublic
} from "@/configuration";
import { mapState } from "vuex";
import Currency from "@/components/Currency.vue";
import DniField from "@/components/DniField.vue";

@Component({
  metaInfo: {
    title: "Solicitante",
    titleTemplate: TitleTemplatePublic,
    htmlAttrs: {
      // @ts-ignore
      lang: RedCapital[SelectedCountry].Lang
    }
  },
  computed: mapState(["user"]),
  data() {
    return {
      RedCapital,
      SelectedCountry,
      ruc: "",
      el: 1,
      simulateAmount: 1000000,
      step1: false,
      valid: true,
      errorMessage: null
    };
  },
  components: {
    Currency,
    DniField
  }
})
export default class Applicant extends Vue {}
